import { inView, animate, scroll, stagger } from "motion";

document.addEventListener('DOMContentLoaded', () => {
    const blockContactHero = document.querySelector('.block-contact-hero');

    // Check if the homepage hero block exists
    if (!blockContactHero) {
        return;
    }

    const blockContactHeroContentHeading = blockContactHero.querySelector('.block-contact-hero__content__heading');
    const blockContactHeroContentHeadingWords = blockContactHeroContentHeading.querySelectorAll('span'); // All heading words are wrapped in a <span> element.
    const blockContactHeroContentForm = blockContactHero.querySelector('.block-contact-hero__content__form');
    const blockContactHeroContentSpinner = blockContactHero.querySelector('.block-contact-hero__content__spinner');

    // Animate each word to fade in one after another with a stagger.
    animate(blockContactHeroContentHeadingWords, 
        { 
            opacity: [0, 1], // Fade in (opacity transition from 0 to 1).
            transform: ['translateY(40px)', 'translateY(0)'], // Slight upward movement.
        },
        { 
            duration: 0.6, // Animation duration.
            delay: stagger(0.15, { startDelay: 0.3 }) // Delay before animation starts and stagger words.
        }
    );
    animate(blockContactHeroContentForm, 
        { 
            opacity: [0, 1], // Fade in (opacity transition from 0 to 1).
            transform: ['translateY(40px)', 'translateY(0)'], // Slight upward movement.
        },
        { 
            duration: 0.6, // Animation duration.
            delay: 1.2
        }
    );
    animate(blockContactHeroContentSpinner, 
        { 
            opacity: [0, 1], // Fade in (opacity transition from 0 to 1).
        },
        { 
            duration: 0.6, // Animation duration.
            delay: 2.2
        }
    );
});